module.exports = __webpack_public_path__ + "assets/img/info_outline.a624dd2b.svg";